export const Petal = ({ color, size = 36, className = "" }) => (
  <svg width={size} height={size * 1.3} viewBox="0 0 40 52" className={className} aria-hidden="true">
    <defs>
      <linearGradient id={`pg-${color.slice(1)}`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor={color} stopOpacity="0.55" />
        <stop offset="100%" stopColor={color} />
      </linearGradient>
    </defs>
    <path d="M20 2 C34 16 36 34 20 50 C4 34 6 16 20 2 Z" fill={`url(#pg-${color.slice(1)})`} stroke="#c9a04f" strokeWidth="1.2" />
    <path d="M20 10 L20 44" stroke="#fff" strokeOpacity="0.5" strokeWidth="1" />
  </svg>
);
